import React from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import $ from 'jquery';
import { trim } from '../../utils/helper';



class Mantra1_3 extends React.Component {
    constructor() {
        super();
        this.setCroppedImage = this.setCroppedImage.bind(this);
        this.state = {
            image: null,
            recursion: null,
            timer: null,
            cropper: null
        }
    }
    setCroppedImage = () => {
        //this.cropper.setCanvasData( { "left": "0", "top": "0" } );
        var ref = this;
        if (this.state.image != null && this.cropper.getCroppedCanvas()) {
            var canvas = trim(this.cropper.getCroppedCanvas());
            if (canvas) {
                this.props.setCroppedImage(canvas.toDataURL());
            } else {
                this.props.setCroppedImage(null);
            }

        }
        var timer = setTimeout(function () {
            ref.setCroppedImage();
        }, 1000)
        this.setState({ timer: timer });

    }
    componentDidMount() {
        this.setState({ image: this.props.image });
        //     this.setCroppedImage();

    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.image != this.state.image) {
            var timer = this.state.timer;
            if (timer != null) {
                window.clearTimeout(this.state.timer);
            }
            this.setState({ image: nextProps.image });
        }
    }
    setCropper = (instance) => {
        this.setState({ cropper: instance })
    }
    getCropData = (done) => {
        let { cropper } = this.state;
        if (typeof cropper !== "undefined") {
            let setCropData = cropper.getCroppedCanvas().toDataURL();
            this.props.setCroppedImage(setCropData, done);
        }

    }
    render() {
        if (this.state.image) {
            return (

                <div className="imgediting">
                    <div className="img_bg">
                        <div className="container">
                            <div className="img_heading">
                                <h4>Image Editing</h4>
                            </div>
                        </div>
                    </div>
                    <div className="img_frame_padding">
                        <div className="container">
                            <div className="img_frame">
                                <ul>
                                    <li>
                                        <img src="/assets/img/cross.png" onClick={() => { this.props.hideCropper() }} className="img-fluid" alt="" />
                                        CANCEL
                                    </li>
                                    <li>
                                        <img src="/assets/img/refresh.png" className="img-fluid" alt="" onClick={() => { this.props.hideCropper() }} />
                                        UNDO
                                    </li>
                                    <li>
                                        <img src="/assets/img/check2.png" onClick={() => { this.getCropData() }} className="img-fluid" alt="" />
                                        DONE
                                    </li>
                                </ul>
                                <Cropper
                                    style={{ height: 250, width: "100%" }}
                                    initialAspectRatio={1}
                                    // preview=".img-preview"
                                    src={this.state.image}
                                    viewMode={0}
                                    dragMode="move"
                                    guides={true}
                                    minCropBoxWidth={$(".crop_holder_parent").width()}
                                  //  minCropBoxHeight={$(".crop_holder_parent").height()}
                                    minCanvasWidth={$(".crop_holder_parent").width()}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    cropBoxMovable={true}
                                    movable={false}
                                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                                    onInitialized={(instance) => {
                                        this.setCropper(instance);
                                    }}
                                />
                                {/* <img src="/assets/img/img-4.jpg" className="img-fluid" alt="" /> */}
                            </div>
                        </div>
                    </div>
                    <div className="img_bg">
                        <div className="container">
                            <div className="preview_btn">
                                <button type="button" onClick={() => { this.getCropData() }}>Preview</button>
                            </div>
                        </div>
                    </div>
                </div>

            )
        } else {
            return null;
        }
    }
}

export default Mantra1_3;